exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".image-view {\n  position: relative;\n}\n.image-view img {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.image-view .mask {\n  width: 100%;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  position: absolute;\n  top: 0;\n  left: 0;\n  background-color: rgba(0, 0, 0, 0.3);\n  opacity: 0;\n}\n.image-view .mask .anticon {\n  font-size: 20px;\n  color: #fff;\n  cursor: pointer;\n  margin: 0 5px;\n}\n.image-view .mask:hover {\n  opacity: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"modules":false,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./~/less-loader/dist/cjs.js?{"modifyVars":{"@primary-color":"#0070C2","@font-size-base":"12px","@primary-1 ":"#f2f2f2"}}!./src/components/ImageView/index.less
// module id = 1242
// module chunks = 0